module.exports = "https://static.wanderu.com/ui-react/_next/static/media/thrillist.00dcb2ec.png";